var TECL_ContactForm = {
    Initialise: function() {
        var recaptcha1;
        var recaptcha2;
        var recaptcha3;
        var recaptcha4;
        var recaptcha5;
        var recaptcha6;
        var recaptcha7;
        var recaptcha8;
        var recaptchaCallback = function() {
            recaptcha1 = grecaptcha.render('recaptcha1',
            { 'sitekey': '6LfV4wgUAAAAAJJJS3BJg-NQPEEuXoWMtWOmI_HM', 'theme': 'light' });
            recaptcha2 = grecaptcha.render('recaptcha2',
            { 'sitekey': '6LfV4wgUAAAAAJJJS3BJg-NQPEEuXoWMtWOmI_HM', 'theme': 'light' });
            recaptcha3 = grecaptcha.render('recaptcha3',
            { 'sitekey': '6LfV4wgUAAAAAJJJS3BJg-NQPEEuXoWMtWOmI_HM', 'theme': 'light' });
            recaptcha4 = grecaptcha.render('recaptcha4',
            { 'sitekey': '6LfV4wgUAAAAAJJJS3BJg-NQPEEuXoWMtWOmI_HM', 'theme': 'light' });
            recaptcha5 = grecaptcha.render('recaptcha5',
            { 'sitekey': '6LfV4wgUAAAAAJJJS3BJg-NQPEEuXoWMtWOmI_HM', 'theme': 'light' });
            recaptcha6 = grecaptcha.render('recaptcha6',
            { 'sitekey': '6LfV4wgUAAAAAJJJS3BJg-NQPEEuXoWMtWOmI_HM', 'theme': 'light' });
            recaptcha7 = grecaptcha.render('recaptcha7',
            { 'sitekey': '6LfV4wgUAAAAAJJJS3BJg-NQPEEuXoWMtWOmI_HM', 'theme': 'light' });
            recaptcha8 = grecaptcha.render('recaptcha8',
            { 'sitekey': '6LfV4wgUAAAAAJJJS3BJg-NQPEEuXoWMtWOmI_HM', 'theme': 'light' });
        }

        $(function() {
            $("#enquiryType")
                .change(function() {
                    $(".ETForm").hide();
                    if ($(this).val() === "ET1") {
                        $("#ET1Form").show();
                        $("#HiddenET1").val($(this).val());
                    } else if ($(this).val() === "ET2") {
                        $("#ET2Form").show();
                        $("#HiddenET2").val($(this).val());
                    } else if ($(this).val() === "ET3") {
                        $("#ET3Form").show();
                        $("#HiddenET3").val($(this).val());
                    } else if ($(this).val() === "ET4") {
                        $("#ET4Form").show();
                        $("#HiddenET4").val($(this).val());
                    } else if ($(this).val() === "ET5") {
                        $("#ET5Form").show();
                        $("#HiddenET5").val($(this).val());
                    } else if ($(this).val() === "ET6") {
                        $("#ET6Form").show();
                        $("#HiddenET6").val($(this).val());
                    } else if ($(this).val() === "ET7") {
                        $("#ET7Form").show();
                        $("#HiddenET7").val($(this).val());
                    } else if ($(this).val() === "ET8") {
                        $("#ET8Form").show();
                        $("#HiddenET8").val($(this).val());
                    }
                });

            $("#enquiryType").change(); //call this on page load for postbacks
            $(".form-group.datepicker").datepicker({
                format: 'dd/mm/yyyy'
            }); //Initialise any date pickers
        });
    }
};